import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import DatePickerComponent from '../../../common/DatePickerComponent';
import { getSourceListList, getAllCarrierList } from '../../../../store/actions/incoming';

const toOptions = (list, valueField, labelField) =>
  (Array.isArray(list) ? list : []).map((item) => ({ ...item, value: item[valueField], label: item[labelField] }));

const UnassignedReturnsFilter = ({ draft, setDraft, reasonOptions, ocrStatusOptions, onApply, onClear }) => {
  const dispatch = useDispatch();
  const sourcesList = useSelector((state) => state?.IncomingReducer?.sourcesList);
  const carriersList = useSelector((state) => state?.IncomingReducer?.allCarriersList);

  useEffect(() => {
    if (!sourcesList?.length) dispatch(getSourceListList());
    if (!carriersList?.length) dispatch(getAllCarrierList());
  }, []);

  const sourceOptions = useMemo(() => toOptions(sourcesList, 'id', 'source'), [sourcesList]);
  const carrierOptions = useMemo(() => toOptions(carriersList, 'id', 'carrierCompanyName'), [carriersList]);

  const update = (field, value) => setDraft((prev) => ({ ...prev, [field]: value || [] }));

  const handleDateChange = (date, field) => {
    if (field === 'fromDate' && draft.toDate && date > draft.toDate) {
      toast.error('From Date cannot be later than To Date');
      return;
    }
    setDraft((prev) => ({ ...prev, [field]: date }));
  };

  const renderSelect = (label, icon, field, options, placeholder) => (
    <div className="col-lg-2 col-md-4 col-sm-6 col-12">
      <div className="row">
        <div className="col-12">
          <div className="labelHead"><i className={`fa ${icon} mr-2`} /> {label}</div>
        </div>
        <div className="col-12 fontFix">
          <Select
            closeMenuOnSelect={false}
            value={draft[field]}
            onChange={(value) => update(field, value)}
            options={options}
            className="react-select-container"
            classNamePrefix="react-select"
            placeholder={placeholder}
            isClearable
            isMulti
          />
        </div>
      </div>
    </div>
  );

  const renderDate = (label, field) => (
    <div className="col-lg-2 col-md-4 col-sm-6 col-12">
      <div className="row">
        <div className="col-12">
          <div className="labelHead"><i className="fa fa-calendar mr-2" /> {label}</div>
        </div>
        <div className="col-12 fontFix">
          <DatePickerComponent
            dateField={draft[field]}
            handleDateChange={(date) => handleDateChange(date, field)}
            fieldName={field}
            dateFormat="MM-dd-yyyy"
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="filter_box_main">
      <div className="filter_box">
        <div className="row">
          {renderSelect('Source', 'fa-flag', 'sources', sourceOptions, 'Select Source')}
          {renderSelect('Carrier', 'fa-truck', 'carriers', carrierOptions, 'Select Carrier')}
          {renderSelect('Unassigned Reason', 'fa-exclamation-circle', 'reasons', reasonOptions, 'Select Reason')}
          {renderSelect('OCR Status', 'fa-file-text-o', 'ocrStatuses', ocrStatusOptions, 'Select OCR Status')}
          {renderDate('From Date', 'fromDate')}
          {renderDate('To Date', 'toDate')}
          <div className="col-12 mt-3">
            <div className="d-flex gap-3 align-items-center justify-content-end">
              <button className="btn cus-primary-transparent-btn clrBtn mr-2" onClick={onClear}>Clear</button>
              <button className="btn cus-seconday-bg-btn applyBtn" onClick={onApply}>Apply Filter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UnassignedReturnsFilter.propTypes = {
  draft: PropTypes.object.isRequired,
  setDraft: PropTypes.func.isRequired,
  reasonOptions: PropTypes.array.isRequired,
  ocrStatusOptions: PropTypes.array.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default UnassignedReturnsFilter;
